import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{ $isEmpty: boolean }>`
  margin-top: 24px;
  ${(props) =>
    props.$isEmpty
      ? css`
          .ant-select-selection {
            height: 40px;
            .ant-select-selection__rendered {
              height: 100%;
            }
          }
          .ant-select-selection--multiple {
            padding-bottom: 0;
          }
          .ant-select-arrow {
            top: 20px;
          }
          input {
            margin-top: 5px;
          }
        `
      : css`
          .ant-select-selection {
            min-height: 60px;
            max-height: 160px;
            overflow: auto;
            padding-bottom: 5px !important;
            .ant-select-selection__rendered {
              height: 100%;
              li {
                height: 100%;
                background-color: unset;
                margin-top: 4px;
                line-height: 0;
                padding-right: 0;
              }
            }
          }
          .ant-select-selection--multiple {
            padding-bottom: 0;
          }
          .ant-select-selection__choice__content {
            > div {
              margin-top: 0px;
              margin-bottom: 0px;
              border: 1px solid #bfbfbf;
              border-radius: 8px;
              padding: 4px 6px;
              > svg {
                display: initial;
                cursor: pointer;
                margin: 0 2px 0 8px;
              }
            }
          }
          .ant-select-arrow {
            top: 50%;
          }
          .ant-select-disabled {
            .ant-select-selection__choice__content {
              > div {
                > svg {
                  pointer-events: none;
                }
              }
            }
          }
          input {
            margin-top: 15px;
          }
        `}
`

export const Subtitle = styled.div`
  color: #757575;
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 4px;
`

export const OptionWrapper = styled.div`
  margin-top: -7px;
  margin-bottom: -7px;
  display: flex;
  align-items: center;
  small {
    font-size: 12px !important;
    line-height: 1.2;
  }
  svg {
    display: none;
  }
  span > svg {
    display: initial !important;
    margin-top: 5px;
  }
`
